var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tiptap',{attrs:{"lang":"zh","height":_vm.height,"placeholder":"请输入内容","extensions":_vm.extensions,"readonly":false},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }